import { withBooking } from 'components/queries/GetBookingQuery';
import { withRouter } from 'react-router';

import FlowForwardCappedSeatSelection from './FlowForwardCappedSeatSelection.js';

export default withBooking(withRouter(FlowForwardCappedSeatSelection));
